import { Type } from '@angular/core';
import { AppDialogParam } from './app-dialog';
import { AppDialogRef } from './app-dialog-reference';

/**
 * Interfaz para el gateway de diálogos
 */
export abstract class AppDialogGateway {
  /**
   * Muestra un modal con el componente indicado
   * @param {Type<unknown>} component componente a mostrar
   * @param {AppDialogParam} params parámetros del diálogo
   * @returns {AppDialogRef} referencia al diálogo, sirve para cerrarlo o obtener el resultado
   */
  abstract show(
    component: Type<unknown>,
    params?: AppDialogParam
  ): AppDialogRef;

  abstract getRef(): AppDialogRef;

  abstract getParams(): AppDialogParam;
}
